module.exports = __webpack_public_path__ + "img/not-found-image.a5fd1304.png";